import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenService } from '@shared/services/token.service';

@Injectable()
export class AdminGuard  {

	constructor(
		private tokenService: TokenService,
		public router: Router) {

	}

	async canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

		const isAdmin = await this.tokenService.hasAdminRole();
		if (!isAdmin) {

			this.router.navigate(['/']);
			return false;
		}

		return true;
	}
}